export var ClientVisibilityState = /*#__PURE__*/function (ClientVisibilityState) {
  ClientVisibilityState["VISIBLE"] = "visible";
  ClientVisibilityState["HIDDEN"] = "hidden";
  ClientVisibilityState["PRERENDER"] = "prerender";
  return ClientVisibilityState;
}({});
export var ClientCauseReason = /*#__PURE__*/function (ClientCauseReason) {
  ClientCauseReason["INITIALIZATION"] = "initialization";
  ClientCauseReason["POLLING"] = "polling";
  ClientCauseReason["RETRY"] = "retry";
  return ClientCauseReason;
}({});
export var ClientStorageState = /*#__PURE__*/function (ClientStorageState) {
  ClientStorageState["AVAILABLE"] = "available";
  ClientStorageState["NOT_AVAILABLE"] = "notAvailable";
  ClientStorageState["FULL"] = "full";
  ClientStorageState["ERRORED"] = "errored";
  return ClientStorageState;
}({});
export var ClientUserState = /*#__PURE__*/function (ClientUserState) {
  ClientUserState["NEW"] = "new";
  ClientUserState["SAME"] = "same";
  ClientUserState["SWITCHED"] = "switched";
  return ClientUserState;
}({});